<script>
    import css from "../currency.css";

    export let amount;
    export let prevAmount;
    export let options;

    $: digits = amount.toString().length;

    // optionally animate numbers
    function numberScroller(node, { duration = 500 }) {
        if (duration === 0) {
            return;
        }

        const valid = (
            node.childNodes.length === 1 &&
            node.childNodes[0].nodeType === Node.TEXT_NODE
        );

        if (!valid) {
            throw new Error(`This transition only works on elements with a single text node child`);
        }

        return {
            duration,
            tick(t) {
                const curAmount = prevAmount + Math.floor((amount - prevAmount) * t);

                // assigning to node.textContent will convert the value to string
                // node.textContent = node.textContent.toLocalString() won't work
                node.textContent = digits > 3 ?
                    curAmount.toLocaleString(window.native.stats.language) :
                    curAmount;
            }
        };
    }
</script>

{#key amount}
    <span
        class="{css.gems}"
        data-waiting={options.waiting}
        data-digits={digits}
        in:numberScroller={{ duration : prevAmount ? options.duration : 0 }}
    >
        {digits > 3 ?
            amount.toLocaleString(window.native.stats.language) :
            amount
        }
    </span>
{/key}